import { Injectable, Injector } from '@angular/core';
import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
  HttpResponse
} from '@angular/common/http';
import { CompanyStorageService } from './company.storage';
import { MaintenanceService } from '../maintenance/maintenance.service';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';

@Injectable()
export class CompanyInterceptor implements HttpInterceptor {
  constructor(
    private companyStorage: CompanyStorageService,
    private injector: Injector,
    private maintenance: MaintenanceService
  ) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const verifyToken = this.companyStorage.getVerifyToken();

    const cloned = req.clone();

    return next.handle(verifyToken && req.url.includes('/api') ? cloned : req).pipe(
      tap((event: HttpEvent<any>) => {
        if (!(event instanceof HttpResponse)) return;

        const body: any = event.body;
        const data: any = body?.data;

        const payload=
          body?.error === 0 &&
          typeof data?.status === 'boolean' &&
          typeof data?.header === 'string' &&
          typeof data?.body === 'string';

        if (!payload) return;

        if (data.status === true) {
          this.maintenance.set({
            active: true,
            header: data.header,
            body: data.body,
          });

          const router = this.injector.get(Router);
          if (router.url !== '/error-maintenance') {
            router.navigate(['/error-maintenance']);
          }
        } else {
          this.maintenance.clear();
        }
      })
    );
  }
}
